export default __webpack_public_path__ + "static/media/Buy_bk.13b049f8.svg";